import $ from 'jquery'
import localStorageSupported from 'toxilibs/local_storage_support.js'

const mailForm = {}

mailForm.position = function () {
    const screenHeight = $(window).height()
    $('#ask_for_mail').css('top', 0.5 * (screenHeight - 300) + 'px')
}

let mailFormCallback
let noMailForm


function disableMailForm () {
    noMailForm = true
}


mailForm.isDisabled = function () {
    return noMailForm || (localStorageSupported && localStorage.silentTeacherMailGiven === true)
}


mailForm.show = function (callback) {
    mailFormCallback = callback
    $('#ask_for_mail').fadeIn()
    mailForm.displayed = true
}


function registerEmail (email) {
    $.post('http://www.toxicode.fr/newsletter', {
        notifier_email: email,
        'merge_vars[STEACHER]': true
    }, function () {
        if (localStorageSupported) {
            localStorage.silentTeacherMailGiven = true
        }
    }, 'json')
}


function closeForm () {
    $('#ask_for_mail').fadeOut()
    mailForm.displayed = false
    if (mailFormCallback) {
        mailFormCallback()
    }
}


function submit () {
    const email = $('#mail_field input').val()
    if (email === '') {
        return
    }
    $('#ask_for_mail').fadeOut()
    mailForm.displayed = false

    registerEmail(email)
    disableMailForm()
    if (mailFormCallback) {
        mailFormCallback()
    }
}



$(function () {

    $('#ask_for_mail').click(function (e) {
        e.stopImmediatePropagation()
    })

    $('#ask_for_mail .cancel').click(closeForm)

    $('#ask_for_mail .submit').click(submit)

})

export default mailForm

